

























































import Vue from 'vue'
import { getPathsLine } from '@/components/data/common/helpers'

export default Vue.extend({
  name: 'graph-line',
  props: {
    graphHeight: Number,
    columnWidth: Number,
    strokeWidth: Number,
    circleRadius: Number,
    offsetWidth: Number,
    offsetHeight: Number,
    mainColor: String,
    pathColor: String,
    notes: Array,
    width: String,
    maxWidth: String,
    isStrictLineBetweenCircle: Boolean,
    bottom: String
  },
  data: () => ({
    paths: {
      main: null,
      gradient: null,
      circles: null
    }
  }),
  computed: {
    graphWidth () {
      return this.columnWidth * this.notes.length
    }
  },
  methods: {
    buildLine () {
      this.paths = {
        ...getPathsLine(
          this.graphHeight,
          this.notes,
          this.columnWidth,
          this.circleRadius,
          this.isStrictLineBetweenCircle
        )
      }
    }
  },
  watch: {
    graphWidth () {
      this.buildLine()
    },
    notes: {
      deep: true,
      immediate: true,
      handler () {
        this.buildLine()
      }
    }
  }
})

